import React, { Fragment, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AddProAttribute, AreaNameError, ProAttributes, Save, Title, Type } from "../../../Constant";
import { addAttribute, addAttributeRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";

const AttributeAdd = () => {
    const { register, handleSubmit, control, formState: { errors } } = useForm();
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const connectionOptions = [
        { value: "color", label: "Color" },
        { value: "dropdown", label: "Dropdown" },
        { value: "radio", label: "Radio Button" },
        { value: "checkbox", label: "Checkbox" },
    ];

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = { title: data.title, type: data.type.value }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addAttribute : addAttributeRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                toast.success(addAreaResponse.data.message);
                navigate(`${process.env.PUBLIC_URL}/Products/attribute`);
            } else {
                toast.error(addAreaResponse.data.message);
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (<Transparentspinner />)}
            <Breadcrumbs mainTitle={ProAttributes} parent="Products" title={ProAttributes} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{AddProAttribute}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="title">{Title}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="title" type="text" {...register('title', { required: true })} />
                                <span className="text-danger">{errors.title && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" >{Type} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={connectionOptions}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.category?.message}</p>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default AttributeAdd;